module.exports = __webpack_public_path__ + "img/hero-devices.b9d90067.png";